import styled from 'styled-components';

export const ShadowSquareWrapper = styled.div`
  box-sizing: border-box;
  height: 36px;
  width: 36px;
  background: white;
  border-radius: 6px;
`;
